import React, {Component} from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from "../components/CircularProgress/index";

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
      this.isMountedRef = false;
      Nprogress.start();
    }

    // componentWillMount() {
    //   Nprogress.start();
    // }
    
    async componentDidMount() {
      this.isMountedRef = true;

      try {
        const {default: LoadedComponent} = await importComponent();

        if (!this.isMountedRef) {
          return;
        }

        this.setState({
          component: LoadedComponent
        });
      } finally {
        Nprogress.done();
      }
    }

    componentWillUnmount() {
      this.isMountedRef = false;
      Nprogress.done();
    }

    render() {
      const LoadedComponent = this.state.component;
      const content = LoadedComponent ? (
        <LoadedComponent {...this.props} />
      ) : (
        <div className="loader-view"
             style={{height: 'calc(100vh - 200px)'}}>
          <CircularProgress/>
        </div>
      );

      return (
        <ReactPlaceholder type="text" rows={7} ready={Boolean(LoadedComponent)}>
          {content}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
